<template>
    <!-- ★★★★하단 라인 빼기★★★ -->
    <v-card v-on="cardEventHandler" outlined rounded="lg">
        <div class="pa-20">
            <v-row class="row--large" align="center">
                <v-col v-if="mode == 'form'" cols="auto"><v-simple-checkbox :value="isSelected" color="primary" @click="toggle(item)" /></v-col>
                <v-col cols="12" lg="" class="micepec-item__detail mb-10 mb-lg-0">
                    <v-layout column justify-center class="w-100 h-100">
                        <p class="page-text--sm primary--text">
                            {{ item?.company?.name }}
                        </p>
                        <h5 class="page-text--lg font-weight-medium mb-8 mb-lg-16">
                            <a :href="`/recruitments/${item?.recruitment?._id}`" rel="noopener noreferrer"> {{ item?.recruitment?.subject }} </a>
                        </h5>
                        <v-chip-group>
                            <v-chip v-for="text in item?.recruitment?.employment?.typesTexts?.filter?.((item) => item)" :key="text" small outlined color="grey-d">
                                <span class="grey-6--text">{{ text }}</span>
                            </v-chip>
                        </v-chip-group>
                    </v-layout>
                </v-col>
                <v-col cols="auto" class="d-none d-lg-block">
                    <v-layout align-center class="h-100">
                        <span class="line"></span>
                    </v-layout>
                </v-col>
                <v-col cols="auto">
                    <v-layout column justify-center align-center class="text-lg-center w-100 h-100 duration-wrap">
                        <micepec-record-item-duration v-bind="item.recruitment" />
                    </v-layout>
                </v-col>
                <v-col cols="auto" class="d-none d-lg-block">
                    <v-layout align-center class="h-100">
                        <span class="line"></span>
                    </v-layout>
                </v-col>
                <v-col cols="auto">
                    <v-layout column justify-center align-center class="w-100 h-100 pr-lg-20">
                        <micepec-record-certification :value="item">
                            <template #activator="{ attrs, on }">
                                <v-btn icon x-large color="grey-f7" v-bind="attrs" v-on="on">
                                    <i :class="`${item?.isCertified ? 'icon icon-cert-on' : 'icon icon-cert-off'}`"></i>
                                </v-btn>
                            </template>
                        </micepec-record-certification>
                        <v-overlay v-if="mode == 'form'" absolute color="transparent"></v-overlay>
                    </v-layout>
                </v-col>
            </v-row>
        </div>
    </v-card>
    <!-- <v-card v-on="cardEventHandler" outlined rounded="lg">
        <v-row align="center" class="ma-0">
            <v-col v-if="mode == 'form'" cols="auto" class="pr-0">
                <v-simple-checkbox :value="isSelected" color="primary" @click="toggle(item)" />
            </v-col>
            <v-col class="pa-20">
                <v-card-subtitle class="primary--text py-0 px-0 page-text--sm">
                    {{ item?.company?.name }}
                </v-card-subtitle>
                <v-card-title style="height: auto;" class="py-0 px-0 font-size-20"> {{ item?.recruitment?.subject }} </v-card-title>
                <v-card-text class="pt-16 pb-0 px-0">
                    <v-chip-group>
                        <v-chip v-for="text in item?.recruitment?.employment?.typesTexts" :key="text" small outlined> {{ text }} </v-chip>
                    </v-chip-group>
                </v-card-text>
            </v-col>
            <v-col cols="auto" class="align-self-stretch py-28 px-0"> <v-divider vertical /> </v-col>
            <v-col cols="auto px-lg-40 px-20">
                <micepec-record-item-duration v-bind="item.recruitment" />
            </v-col>
            <v-col cols="auto" class="align-self-stretch py-28 px-0"> <v-divider vertical /> </v-col>
            <v-col cols="auto" style="position: relative" class="px-20 px-lg-40">
                <v-btn fab class="border-radius-circle">
                    <v-icon :color="`${item?.isCertified ? '#FFCA08' : 'grey'}`">mdi-seal</v-icon>
                </v-btn>
                <v-overlay absolute color="transparent"></v-overlay>
            </v-col>
        </v-row>
    </v-card> -->
</template>

<script>
import MicepecRecordCertification from "./micepec-record-certification.vue";
import MicepecRecordItemDuration from "./micepec-record-item-duration.vue";

export default {
    components: {
        MicepecRecordItemDuration,
        MicepecRecordCertification,
    },
    props: {
        value: { type: Array, default: () => [] }, // selected
        item: { type: Object, default: () => ({}) }, // application
        mode: { type: String, default: "form" },
    },
    computed: {
        cardEventHandler() {
            if (this.mode == "form") return { click: this.toggle };
            else return {};
        },
        isSelected() {
            return this.value.includes(this.item?._id);
        },
    },
    methods: {
        toggle() {
            let list = this.isSelected ? [...this.value.filter((_id) => _id != this.item?._id)] : [...this.value, this.item?._id];

            this.$emit("input", list);
        },
    },
};
</script>

<style lang="scss" scoped>
.line {
    margin: auto;
    display: block;
    width: 1px;
    height: 60px;
    background-color: var(--border-color);
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .duration-wrap {
        max-width: 192px;
        min-width: 192px;
    }
    .micepec-item__detail {
        max-height: calc(100% - 430px);
    }
}
@media (min-width: 1200px) {
}
</style>
